import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import es from "./es.json";
import nl from "./nl.json";
import pap from "./pap.json";
import { DEFAULT_LOCALE } from "./locales";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    nl: { translation: nl },
    pap: { translation: pap }
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: {
    escapeValue: false
  },
  returnNull: false
});

export default i18n;
